import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'index',
      component: () => import('@/views/index.vue'),
    },
    {
      path: '/home',
      name: 'index',
      component: () => import('@/views/index.vue'),
    },
    {
      path: '/about_us',
      name: 'about_us',
      component: () => import('@/views/about_us.vue'),
    },
    {
      path: '/AIR_FREIGHT',
      name: 'AIR FREIGHT',
      component: () => import('@/views/Air.vue'),
    },
    {
      path: '/Container_Wharf_Transport',
      name: 'Container & Wharf Transport',
      component: () => import('@/views/Container_Wharf_Transport.vue'),
    },
    {
      path: '/sea_freight',
      name: 'sea_freight',
      component: () => import('@/views/sea_freight.vue'),
    },
    {
      path: '/Courier',
      name: 'Courier',
      component: () => import('@/views/Courier.vue'),
    },
    {
      path: '/Warehousing',
      name: 'Warehousing',
      component: () => import('@/views/Warehousing.vue'),
    },

    {
      path: '/projects',
      name: 'projects',
      component: () => import('@/views/projects.vue'),
    },
    {
      path: '/contact_us',
      name: 'contact_us',
      component: () => import('@/views/contact_us.vue'),
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js